<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:150px;">
                        <el-select v-model="queryForm.productType" placeholder="请选择商品类型" clearable>
                            <el-option
                                v-for="item in productTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:150px;">
                        <el-select v-model="queryForm.buyDateType" placeholder="请选择购买类型" clearable>
                            <el-option
                                v-for="item in buyDateTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1; getData()">查询</el-button>
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary" class="mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                </div>
            </div>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                height="550"
                row-key="id"
                border
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)"
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="productType" label="商品类型" min-width="110">
                    <template slot-scope="scope">
                        {{ productTypeLabel(scope.row.productType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="buyDateType" label="购买类型" min-width="110">
                    <template slot-scope="scope">
                        {{ buyDateTypeLabel(scope.row.buyDateType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="金额(元)" min-width="100">
                    <template slot-scope="scope">
                        {{ formatAmount(scope.row.amount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="setPrivileges" label="关联的特权" min-width="220" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="setSchools" label="关联的学校" min-width="220" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间" min-width="170"></el-table-column>
                <el-table-column fixed="right" label="操作" width="220">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="setUpdate(scope.row)" type="text" size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button @click.native.prevent="setPrivilege(scope.row)" type="text" size="small">
                            <span style="color: #387EE8;">设置会员特权</span>
                        </el-button>
                        <el-button @click.native.prevent="setSchool(scope.row)" type="text" size="small">
                            <span style="color: #387EE8;">设置学校</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)" type="text" size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>

        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <div v-if="setPrivilegeVisible">
            <setPrivilege ref="setPrivilege"></setPrivilege>
        </div>
        <div v-if="setSchoolVisible">
            <setSchool ref="setSchool"></setSchool>
        </div>
    </div>
</template>

<script>
import http from '../../../../common/http';
import add from './Add.vue';
import update from './Update.vue';
import setPrivilege from './SetPrivilege.vue';
import setSchool from './SetSchool.vue';

export default {
    name: 'MemberProduct',
    data(){
        return{
            menuName: '',
            loading: false,
            loadingText: '',
            addVisible: false,
            updateVisible: false,
            setPrivilegeVisible: false,
            setSchoolVisible: false,
            data: [],
            queryForm: {
                productType: '',
                buyDateType: ''
            },
            form: {
                id: ''
            },
            common: {
                total: 0,
                pageSize: 30,
                page: 1,
                isPage: 1,
                allSizes: [30, 50, 100]
            },
            productTypeOptions: [
                { value: '1', label: 'VIP' },
                { value: '2', label: 'SVIP' },
                { value: '3', label: 'BVIP' }
            ],
            buyDateTypeOptions: [
                { value: '1', label: '半年' },
                { value: '2', label: '包年' }
            ]
        };
    },
    components: {
        add,
        update,
        setPrivilege,
        setSchool
    },
    created:function () {
        this.menuName = sessionStorage.getItem('selectMenuItem_key');
        this.getData();
    },
    methods:{
        indexMethod(index) {
            return (this.common.page - 1) * this.common.pageSize + (index + 1);
        },
        getData(){
            this.loading = true;
            this.loadingText = '数据加载中...';
            let url = this.memberProductListUrl;
            let data = {
                isPage: this.common.isPage,
                page: this.common.page,
                limit: this.common.pageSize,
                productType: this.queryForm.productType,
                buyDateType: this.queryForm.buyDateType
            };
            this.apiPost(url, data).then((res) => {
                this.loading = false;
                if(res.status == 200){
                    this.data = res.data.list || res.data.data || [];
                    this.common.total = res.data.total || 0;
                }else{
                    this.$commonFn.showTip(res.message,3);
                }
            },(err)=>{
                console.log(err);
                this.loading = false;
            });
        },
        handleSizeChange(val) {
            this.common.pageSize = val;
            this.common.page = 1;
            this.getData();
        },
        handleCurrentChange(val) {
            this.common.page = val;
            this.getData();
        },
        setAdd(){
            this.addVisible = true;
            this.$nextTick(() => {
                this.$refs['add'].init();
            });
        },
        setUpdate(row){
            this.updateVisible = true;
            this.$nextTick(() => {
                this.$refs['update'].init(row);
            });
        },
        setPrivilege(row){
            this.setPrivilegeVisible = true;
            this.$nextTick(() => {
                this.$refs['setPrivilege'].init(row);
            });
        },
        setSchool(row){
            this.setSchoolVisible = true;
            this.$nextTick(() => {
                this.$refs['setSchool'].init(row);
            });
        },
        del(row){
            this.form.id = row.id;
            this.$commonFn.showConfirm(this.delSuccess);
        },
        delSuccess(){
            let url = this.memberProductRemoveUrl;
            let data = { id: this.form.id };
            this.apiPost(url,data).then((res)=>{
                if(res.status === 200){
                    this.$commonFn.showTip(res.message,1);
                    this.getData();
                }else{
                    this.$commonFn.showTip(res.message,3);
                }
            },(err)=>{
                console.log(err);
            });
        },
        productTypeLabel(v){
            if(v == 1 || v == '1') return 'VIP';
            if(v == 2 || v == '2') return 'SVIP';
            if(v == 3 || v == '3') return 'BVIP';
            return '-';
        },
        buyDateTypeLabel(v){
            if(v == 1 || v == '1') return '半年';
            if(v == 2 || v == '2') return '包年';
            return '-';
        },
        formatAmount(v){
            if(v === null || v === undefined || v === ''){
                return '';
            }
            let n = parseFloat(v);
            if(isNaN(n)){
                return v;
            }
            if(Math.floor(n) === n){
                return String(parseInt(n, 10));
            }
            return String(n);
        }
    },
    mixins: [http]
};
</script>

<style scoped>
.table{
    width: 100%;
    font-size: 14px;
}
.mr10{
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/member/product/Product.vue